import store from '@/store'

/** 判断是否有按钮权限
 * @param {String} value
 * @returns {Boolean}
 * @example
 */
export function checkPermission(values) {
  if (values && values.length > 0) {
    let isShwo = false
    const value = values.split(',')
    const permissionList = store.getters.permission
    for (const i in value) {
      isShwo = permissionList.indexOf(value[i]) > -1
      if (isShwo) {
        break
      }
    }
    return isShwo
  } else {
    return false
  }
}
